import React, { useEffect, useState } from 'react';
import { Download, RefreshCw, X } from 'lucide-react';
import { registerServiceWorker, watchInstallPrompt } from '../pwaRegistration';

const INSTALL_DISMISSED = 'webfoxx.installDismissed';

// PWA install + update prompts (PRD Module 7.7).
//
// Both are inert outside production: registerServiceWorker() no-ops in dev, and
// `beforeinstallprompt` only fires in Chromium browsers over HTTPS.
export function PwaPrompts() {
  const [applyUpdate, setApplyUpdate] = useState<(() => void) | null>(null);
  const [showInstall, setShowInstall] = useState<(() => Promise<void>) | null>(null);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    registerServiceWorker();

    if (localStorage.getItem(INSTALL_DISMISSED) !== '1') {
      watchInstallPrompt((show) => setShowInstall(() => show));
    }
  }, []);

  const dismissInstall = () => {
    localStorage.setItem(INSTALL_DISMISSED, '1');
    setShowInstall(null);
  };

  const install = async () => {
    if (!showInstall) return;
    await showInstall();
    setShowInstall(null);
  };

  return (
    <>
      {applyUpdate && (
        <div className="pwa-toast pwa-update" role="status" aria-live="polite">
          <RefreshCw size={16} aria-hidden="true" />
          <p>A new version of WebFoxx Academy is available.</p>
          <button
            className="primary-action compact"
            disabled={updating}
            onClick={() => { setUpdating(true); applyUpdate(); }}
          >
            {updating ? 'Updating…' : 'Reload'}
          </button>
          <button className="pwa-dismiss" aria-label="Dismiss update notice" onClick={() => setApplyUpdate(null)}>
            <X size={15} aria-hidden="true" />
          </button>
        </div>
      )}

      {showInstall && (
        <div className="pwa-toast pwa-install" role="status" aria-live="polite">
          <Download size={16} aria-hidden="true" />
          <p>Install WebFoxx Academy for offline access and a full-screen study session.</p>
          <button className="primary-action compact" onClick={install}>Install</button>
          <button className="pwa-dismiss" aria-label="Dismiss install prompt" onClick={dismissInstall}>
            <X size={15} aria-hidden="true" />
          </button>
        </div>
      )}
    </>
  );
}
